var CarFiltering = {
    addLocationClasses: function ($locations) {
        $locations.each(function (i, e) {
            $(e).closest('tr').addClass(CarFiltering.slugify($(e).text()));
        })
    }, 
    setupFiltering: function ($locations, $button, $dropdowns) {
        CarFiltering.addLocationClasses($locations);
        $button.click(function () {
            CarFiltering.updateTable($dropdowns.val());
        });
    },
    updateTable: function (filterKey) {
        switch (filterKey) {
            case 'all':
                $('tbody tr').removeClass('hidden');
                break;
            default:
                $('tbody tr').addClass('hidden');
                $('tbody tr.' + filterKey).removeClass('hidden');
        }
    },
    Location: function (name) {
        this.id = CarFiltering.slugify(name);
        this.name = name;
    },
    getLocations: function ($locations) {
        var locations = [];
        $locations.each(function (i, e) {
            var el = $(e).text();
            if ($.inArray(el, locations) === -1) locations.push(el);
        });
        var newLocations = [];
        $.each(locations, function (i, el) {
            newLocations.push(new CarFiltering.Location(el));
        });
        return newLocations;
    }, 
    addToDropdown: function (locations, $dropdown) {
    $(locations).each(function (i, e) {
        var option = '<option value="' + e.id + '">' + e.name + '</option>';
        $dropdown.append(option);
    });
},
    slugify: function (text) {
        return text.toString().toLowerCase()
            .replace(/\s+/g, '-')           // Replace spaces with -
            .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
            .replace(/\-\-+/g, '-')         // Replace multiple - with single -
            .replace(/^-+/, '')             // Trim - from start of text
            .replace(/-+$/, '');            // Trim - from end of text
    }
};
module.exports = CarFiltering;